import SettingsConst from "./settings-const";
import SettingsFilters from "./filters";
import SettingsHelpers from "./helpers";
import SettingsCharts from "./charts";


const Settings = {
    Const: SettingsConst,
    Filters: SettingsFilters,
    Helpers: SettingsHelpers,
    Charts: SettingsCharts,
};

export default Settings;
